import Layout from 'Nori/Layout';
import Hero from 'Custom/Hero';
import RichText from 'Custom/RichText';
import Container from 'Nori/Container';
import { AlternativeTable } from 'Custom/Table/AlternativeTable';
import BannerCTA from '../components/Custom/BannerCTA';
import { SE_TABLE_3 } from 'Utils/side-effects';
import PLUS_IMAGE from 'Images/misc/Plus-sign.png';
import SMALL_BANNER from 'Images/misc/calling-dr-small-banner.png';
import BLUE_BG from 'Images/background/blue-bg.png';
import BLUE_BG_MOBILE from 'Images/background/blue-bg-mobile.png';

import styles from 'styles/pages/callingYourDoctor.module.scss';

const HEAD = {
  title:
    'When to Call Your Doctor While on NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'Know when to call your doctor after getting NEXPLANON® (etonogestrel implant) 68 mg Radiopaque for symptoms that may need immediate attention.',
  keywords:
    'Nexplanon complications, Nexplanon side effects, Nexplanon medical attention',
};

const CTA_BUTTON = {
  showModal: true,
  href: '/',
  label: 'FDA MedWatch',
  target: '_self',
};

export default function CallingYourDoctor() {
  return (
    <Layout head={HEAD}>
      <Hero
        backgroundImage={BLUE_BG.src}
        mobileBackgroundImage={BLUE_BG_MOBILE.src}
        title="WHEN TO CALL YOUR DOCTOR"
        className={styles.customHero}
        image={PLUS_IMAGE}
        mobileImage={PLUS_IMAGE}
        imageBreakpoint="xl"
        variant="overlap"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Hero"
        data-design-module_name="WHEN TO CALL YOUR DOCTOR"
        data-design-module_no="01"
      >
        <RichText>
          <h2>
            if you are experiencing any of these symptoms, contact your doctor
            immediately
          </h2>
          <p>There could be a serious complication, so don’t wait.</p>
        </RichText>
      </Hero>{' '}
      <div
        className={styles.tableBg}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="when should I call my healthcare professional?"
        data-design-module_no="02"
        data-qa-tag="section-when-to-call-doctor"
      >
        <Container data-qa-tag="container-table-content">
          <RichText
            className={styles.tableWrapper}
            data-qa-tag="richtext-table-wrapper"
          >
            <div className={styles.title} data-qa-tag="div-table-title">
              <h2 data-qa-tag="heading-when-to-call-professional">
                When should I call my healthcare professional?
              </h2>
              <p
                data-qa-tag="subheading-call-immediately-if"
                className={styles.subheadingCallImmediatelyIf}
              >
                Call your healthcare professional immediately if you have…
              </p>
            </div>
            <AlternativeTable
              content={SE_TABLE_3}
              className="sm alternative-new-mobile-table"
              title="call your doctor immediately if you have …"
              data-qa-tag="table-call-doctor-symptoms"
            />
          </RichText>
        </Container>
      </div>
      <BannerCTA
        color="marble"
        button={CTA_BUTTON}
        moduleName="report negative side effects of prescription drugs to the FDA"
        moduleNo="03"
        className="calling-dr"
        style={{
          backgroundImage: `url(${SMALL_BANNER.src})`,
        }}
        data-qa-tag="banner-report-side-effects-fda"
      >
        <>
          <h4 data-qa-tag="heading-report-side-effects">
            Report negative side effects of prescription drugs to the FDA
          </h4>
          <p className="intro" data-qa-tag="text-encouraged-to-report">
            You are encouraged to report negative side effects of prescription
            drugs to the US Food and Drug Administration (FDA).
          </p>
        </>
      </BannerCTA>
    </Layout>
  );
}
